// extracted by mini-css-extract-plugin
module.exports = {"actions":"index-module--actions--1v50N Box-module--box--X0EGm"};